<template>
  <v-dialog v-model="show" persistent max-width="675px">
    <v-card>
      <v-card-title>
        <span class="screen-title component">{{ title }}</span>
      </v-card-title>
      <v-card-text>
        <category-form
          :vs="$v"
          :reset.sync="reset"
          with-details
          :initial-values="initialValues"
          :number-of-zones="numberOfZones"
          @values="form = $event"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <main-button
          v-if="initialValues"
          class="mr-16"
          flat
          color="error"
          @click="deleteCategory(eventId, initialValues.id); closeDialog();"
        >
          Delete
        </main-button>
        <main-button class="mr-16" flat @click.stop="closeDialog()">Cancel</main-button>
        <main-button depressed color="primary" @click="submit">{{ okText }}</main-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

import { submitGuard } from '../../utils'
import CategoryForm from './new-category-form.vue'

export default {
  name: 'category-dialog',
  components: {
    CategoryForm,
  },
  props: {
    show: Boolean,
    okText: String,
    eventId: String,
    title: String,
    initialValues: {
      type: Object,
      default: () => {},
    },
    numberOfZones: Number,
    submitForm: Function,
    deleteCategory: Function,
  },
  data() {
    return {
      reset: false,
      form: {},
    }
  },
  validations() {
    return {
      form: {
        name: { required },
        color: { required },
        zones: {
          required,
          minLength: minLength(1),
          maxLength: maxLength(10),
        },
      },
    }
  },
  methods: {
    async submit() {
      await submitGuard(this, async () => {
        await this.submitForm(this.eventId, {
          ...this.form,
        })
        this.reset = true
        this.closeDialog()
      })
    },

    closeDialog() {
      this.reset = true
      this.$emit('resetSelectedCategory')
      this.$emit('update:show', false)
    },
  },
}
</script>

<style scoped>
.zones {
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  margin-bottom: 8px;
}

.zone {
  border-radius: 50% !important;
  color: #333 !important;
  border: 0;
  opacity: 1 !important;
  width: 28px !important;
  height: 28px;
  margin-right: 8px !important;
}

.zone >>> .v-btn__content {
  font-size: 14px;
  font-weight: bold;
  border: 2px solid #333;
  width: 28px;
  height: 28px;
}

.zone-active >>> .v-btn__content {
  border: 2px solid #0277bd;
  background: #0277bd;
  color: white;
}

.zone >>> .v-btn__content::before {
  display: none;
}
</style>
